export default __webpack_public_path__ + "static/media/Regione-Abruzzo-Stemma-scritta.f963688f.png";